import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import requireAuthContext from '../../authorization/requireAuthContext'
import Entity = com.eidu.sharedlib.entity.Entity
import entityPaginatedResponseWithRelatedFromJsonString = com.eidu.sharedlib.entity.api.entities.entityPaginatedResponseWithRelatedFromJsonString
import EntityId = com.eidu.sharedlib.entity.EntityId
import KtList = kotlin.collections.KtList
import PaginatedResponseWithRelated = com.eidu.api.pagination.PaginatedResponseWithRelated
import IndexedPaginatedResponseWithRelated = com.eidu.api.pagination.IndexedPaginatedResponseWithRelated

type GetEntitiesBatchParameters = {
  ids: EntityId[]
  withRelatedEntities?: boolean
  pageIndex: number
  pageSize: number
}

export const MAX_NUM_IDS_PER_BATCH = 50

const getEntitiesBatch = async ({
  ids,
  withRelatedEntities,
  pageIndex,
  pageSize,
}: GetEntitiesBatchParameters): Promise<PaginatedResponseWithRelated<Entity>> => {
  requireValidPaginationParameters(pageIndex, pageSize)
  if (ids.length === 0) throw Error('ids must not be empty')
  if (ids.length > MAX_NUM_IDS_PER_BATCH)
    throw Error(`ids must not contain more than ${MAX_NUM_IDS_PER_BATCH} elements`)

  const encodedIds = encodeURIComponent(ids.map((it) => it.toString()).join(','))
  const related = withRelatedEntities ? 'true' : 'false'

  const authContext = await requireAuthContext()

  return fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/entities?ids=${encodedIds}&related=${related}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
      },
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return entityPaginatedResponseWithRelatedFromJsonString(await response.text())
      case 401:
      case 403:
        console.warn(`Got status ${response.status} from getEntitiesBatch endpoint`)
        return new IndexedPaginatedResponseWithRelated(KtList.fromJsArray([]), KtList.fromJsArray([]), 0)
      default:
        throw Error(`Unexpected response code ${response.status} from getEntitiesBatch endpoint`)
    }
  })
}

export default getEntitiesBatch
